
export default {
  props: {
    setMajorName: {
      type: Function,
      default: () => "",
    },
    majorName: {
      type: String,
      default: "",
    },
    config: {
      type: Object,
      default: () => ({
        tab1: {
          icon: `${this.BASE_URL_STATIC}/storages/2025-08-14/60b8ae155cd64fff8afdd6565156f963.svg`,
          label: "Ngành học của bạn",
          disabled: false,
          onActiveTab: () => () => { },
        },
        tab2: {
          icon: `${this.BASE_URL_STATIC}/storages/2025-08-14/f81695d0b72b4dd0aed9ac7c29270348.svg`,
          label: "Học phí",
          disabled: false,
          onActiveTab: () => () => { },
        },
      }),
    },
    defaultActiveTab: {
      type: String,
      default: "1",
    },
  },
  data() {
    return {
      BASE_URL_STATIC: this.$config.BASE_URL_STATIC,
      contacts: [
        {
          title: "Địa chỉ 1: ",
          content: "236B Lê Văn Sỹ, phường 1, quận Tân Bình, TP HCM",
          logo: `${this.$config.BASE_URL_STATIC}/storages/2025-08-14/a7c254e3ca414f83bac75c3d0a07ce94.png`,
        },
        {
          title: "Địa chỉ 2: ",
          content: "236B Lê Văn Sỹ, phường 1, quận Tân Bình, TP HCM",
          logo: `${this.$config.BASE_URL_STATIC}/storages/2025-08-14/a7c254e3ca414f83bac75c3d0a07ce94.png`,
        },
        {
          title: "Liên lạc: ",
          content: "028.3991.6415",
          logo: `${this.$config.BASE_URL_STATIC}/storages/2025-08-14/a7c254e3ca414f83bac75c3d0a07ce94.png`,
        },
        {
          title: "Website: ",
          content: "https://vanlanguni.edu.vn",
          logo: `${this.$config.BASE_URL_STATIC}/storages/2025-08-14/a7c254e3ca414f83bac75c3d0a07ce94.png`,
          isLink: true,
        },
      ],
    };
  },
  methods: {
    onClickTab(tab) {
      if (typeof this.setMajorName === "function") {
        this.setMajorName("");
      }
      const tabConfig = this.config[tab];
      if (!tabConfig) return;
      const { onActiveTab } = tabConfig;

      if (onActiveTab && typeof onActiveTab === "function") {
        onActiveTab();
      }
    },
  },
};
